module.exports = __webpack_public_path__ + "img/email-header-happiness@2x.a6708fe8.png";